module.exports = __webpack_public_path__ + "static/media/multiverse3.cab0ebd8.png";